import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    padding: 0,
    outlineColor: 'unset',
    '& .MuiSlider-rail, & .MuiSlider-track, & .MuiSlider-thumb': {
      top: `calc(50% - ${idsTokens.slider.default.sizing.standard.track.height} / 2)`,
    },
  },
  rail: {
    height: idsTokens.slider.default.sizing.standard.track.height,
    backgroundColor: idsTokens.functional.color.surface.background.enabled,
    opacity: 1,
    borderRadius: idsTokens.slider.default.radius.trackBar,
    transform: 'unset',
    border: `1px solid ${idsTokens.functional.color.border.default.enabled}`,
    boxSizing: 'border-box',
    '.MuiSlider-root.Mui-disabled &': {
      backgroundColor: idsTokens.functional.color.surface.background.disabled,
      border: `1px solid ${idsTokens.functional.color.border.default.disabled}`,
    },
  },
  track: {
    height: idsTokens.slider.default.sizing.standard.track.height,
    borderRadius: idsTokens.slider.default.radius.trackBar,
    backgroundColor: idsTokens.slider.default.color.bar.enabled,
    border: 'none',
    transform: 'unset',
    '.MuiSlider-root.MuiSlider-colorError &': {
      backgroundColor: idsTokens.slider.error.color.bar.enabled,
    },
    '.MuiSlider-root.Mui-disabled &': {
      backgroundColor: idsTokens.functional.color.surface.container.solid.brand.disabled,
    },
  },
  thumb: {
    border: `1px solid ${idsTokens.slider.default.color.handle.border.enabled}`,
    backgroundColor: idsTokens.slider.default.color.handle.fill.enabled,
    marginTop: 4,
    height: idsTokens.slider.default.sizing.standard.handle.height,
    width: idsTokens.slider.default.sizing.standard.handle.width,
    filter: 'box-shadow(0px 12px 12px rgba(0, 0, 0, 0.24))',
    '&::before': {
      boxShadow: 'unset',
      outlineOffset: 'unset',
    },
    '&.Mui-focusVisible': {
      boxShadow: 'unset',
      outline: `${idsTokens.functional.borderWidth.focus.default} solid ${idsTokens.functional.color.border.focus}`,
      outlineOffset: 3,
    },
    '&:hover': {
      backgroundColor: idsTokens.slider.default.color.handle.fill.hover,
      outline: `2px solid ${idsTokens.slider.default.color.handle.border.hover}`,
      outlineOffset: -2,
      boxShadow:
        idsTokens.slider.default.shadow.x +
        ' ' +
        idsTokens.slider.default.shadow.y +
        ' ' +
        idsTokens.slider.default.shadow.blur +
        ' ' +
        idsTokens.slider.default.shadow['hover-spread'] +
        ' ' +
        idsTokens.slider.default.shadow.hover,
    },
    '&.Mui-active, &:active': {
      backgroundColor: idsTokens.slider.default.color.handle.fill.pressed,
      outline: `5px solid ${idsTokens.slider.default.color.handle.border.pressed}`,
      outlineOffset: -5,
      boxShadow:
        idsTokens.slider.default.shadow.x +
        ' ' +
        idsTokens.slider.default.shadow.y +
        ' ' +
        idsTokens.slider.default.shadow.blur +
        ' ' +
        idsTokens.slider.default.shadow['pressed-spread'] +
        ' ' +
        idsTokens.slider.default.shadow.pressed,
    },
    '.MuiSlider-root &.Mui-disabled': {
      border: `1px solid ${idsTokens.functional.color.border.default.disabled}`,
      backgroundColor: idsTokens.functional.color.content.defaultInverse.enabled,
    },

    '.MuiSlider-colorError &': {
      border: `1px solid ${idsTokens.slider.error.color.handle.border.enabled}`,
      backgroundColor: idsTokens.slider.error.color.handle.fill.enabled,

      '&.Mui-focusVisible': {
        boxShadow: 'unset',
        outline: `${idsTokens.functional.borderWidth.focus.default} solid ${idsTokens.functional.color.border.focus}`,
        outlineOffset: 3,
      },
      '&:hover': {
        backgroundColor: idsTokens.slider.error.color.handle.fill.hover,
        outline: `2px solid ${idsTokens.slider.error.color.handle.border.hover}`,
        outlineOffset: -2,
        boxShadow:
          idsTokens.slider.error.shadow.x +
          ' ' +
          idsTokens.slider.error.shadow.y +
          ' ' +
          idsTokens.slider.error.shadow.blur +
          ' ' +
          idsTokens.slider.error.shadow['hover-spread'] +
          ' ' +
          idsTokens.slider.error.shadow.hover,
      },
      '&.Mui-active, &:active': {
        backgroundColor: idsTokens.slider.error.color.handle.fill.pressed,
        outline: `5px solid ${idsTokens.slider.error.color.handle.border.pressed}`,
        outlineOffset: -5,
        boxShadow:
          idsTokens.slider.error.shadow.x +
          ' ' +
          idsTokens.slider.error.shadow.y +
          ' ' +
          idsTokens.slider.error.shadow.blur +
          ' ' +
          idsTokens.slider.error.shadow['pressed-spread'] +
          ' ' +
          idsTokens.slider.error.shadow.pressed,
      },
    },
  },
});
